var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    directives: [
      {
        name: "waypoint",
        rawName: "v-waypoint",
        value: { active: _vm.Global.activeWp, callback: _vm.TopWaypoint },
        expression: "{ active: Global.activeWp, callback: TopWaypoint }",
      },
    ],
    staticClass: "top-waypoint",
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }